// extracted by mini-css-extract-plugin
module.exports = {"success":"success-message__success___1BGDG"};